import "./index.css";
import { MantineProvider, ColorSchemeScript } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { WorkspaceProvider } from "./contexts/WorkspaceContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { WorkspaceRedirect } from "./components/WorkspaceRedirect";
import { AppLayout } from "./layouts/AppLayout";
import { DashboardPage } from "./pages/DashboardPage";
import { PromptsPage } from "./pages/PromptsPage";
import { PromptDetailPage } from "./pages/PromptDetailPage";
import { SettingsPage } from "./pages/SettingsPage";
import { WorkspaceSettingsPage } from "./pages/WorkspaceSettingsPage";
import { ProfilePage } from "./pages/ProfilePage";
import { LoginPage } from "./pages/LoginPage";
import { SignupPage } from "./pages/SignupPage";
import { shadcnTheme } from "./theme";
import { shadcnCssVariableResolver } from "./cssVariableResolver";
export function App() {
  return (
    <MantineProvider
      theme={shadcnTheme}
      defaultColorScheme="auto"
      cssVariablesResolver={shadcnCssVariableResolver}
    >
      <Notifications position="bottom-center" autoClose={5000} />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />

            {/* Root — redirect to last-used workspace */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <WorkspaceRedirect />
                </ProtectedRoute>
              }
            />

            {/* Workspace-scoped routes */}
            <Route
              path="/:workspaceId/*"
              element={
                <ProtectedRoute>
                  <WorkspaceProvider>
                    <AppLayout />
                  </WorkspaceProvider>
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="prompts" element={<PromptsPage />} />
              <Route path="prompts/:promptId" element={<PromptDetailPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route
                path="settings/workspace"
                element={<WorkspaceSettingsPage />}
              />
              <Route path="settings/profile" element={<ProfilePage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default App;
